import { useCallback, useEffect, useRef, useState } from "react";

export function useVisibleChildCount(initialCount = 6) {
    const [wrapperEl, setWrapperEl] = useState<HTMLDivElement | null>(null);
    const [visibleCount, setVisibleCount] = useState(initialCount);
    const observerRef = useRef<MutationObserver | null>(null);

    // Called by React when the element mounts or unmounts
    const wrapperRef = useCallback((node: HTMLDivElement | null) => {
        setWrapperEl(node);
    }, []);

    useEffect(() => {
        if (!wrapperEl) return;

        const countVisible = () => {
            const count = [...wrapperEl.children].filter(child => getComputedStyle(child).display !== "none").length;
            setVisibleCount(Math.max(0, count));
        };

        countVisible();

        observerRef.current = new MutationObserver(countVisible);
        observerRef.current.observe(wrapperEl, { childList: true, subtree: true });

        return () => observerRef.current?.disconnect();
    }, [wrapperEl]);

    return { wrapperRef, visibleCount };
}
